// Helper function to format API errors for display
export const formatApiError = (error) => {
  const detail = error?.response?.data?.detail;
  
  if (detail == null) {
    return "Bir hata oluştu. Lütfen tekrar deneyin.";
  }
  
  if (typeof detail === "string") {
    return detail;
  }
  
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  
  if (detail && typeof detail.msg === "string") {
    return detail.msg;
  }
  
  return String(detail);
};
